module.exports = __webpack_public_path__ + "static/media/people.d2ec8a82.svg";